<div class="desktop-container">
  <div class="static-desktop-heading">
    {{ 'howWeInvest.header' | translate }}
  </div>

  <div class="desktop-aligment">
    <div class="desktop-image-container desktop-image-container--how-we-invest"></div>

    <div class="desktop-column">
      <div class="static-heading">
        {{ 'howWeInvest.subHeader1' | translate }}
      </div>

      <div class="static-text static-text--start" [innerHTML]="'howWeInvest.text1' | translate | htmlFormat"></div>

      <div class="phone-image-container">
        <img src="/assets/images/static-pages/foto-jak-investujeme.jpg" alt="how we invest banner">
      </div>

    </div>
  </div>
</div>

<div class="additional-text">

  <div class="row">
    <div class="col-12 col-md-6">
      <div class="static-heading">
        {{ 'howWeInvest.subHeader2' | translate }}
      </div>

      <div class="bullet-list-container">
        <ul class="bullet-list mt-3">
          <li>
            {{ 'howWeInvest.bulletList1.item1' | translate }}
          </li>
          <li>
            {{ 'howWeInvest.bulletList1.item2' | translate }}
          </li>
          <li>
            {{ 'howWeInvest.bulletList1.item3' | translate }}
          </li>
          <li>
            {{ 'howWeInvest.bulletList1.item4' | translate }}
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="static-heading">
        {{ 'howWeInvest.subHeader3' | translate }}
      </div>

      <div class="static-text static-text--start" [innerHTML]="'howWeInvest.text3' | translate | htmlFormat"></div>

      <div class="bullet-list-container">
        <ul class="bullet-list mt-3">
          <li>
            {{ 'howWeInvest.bulletList2.item1' | translate }}
            <div class="tooltip-container">
              <libero-tooltip-button>
                {{ 'howWeInvest.bulletList2.item1Tooltip' | translate }}
              </libero-tooltip-button>
            </div>
          </li>
          <li>
            {{ 'howWeInvest.bulletList2.item2Part1' | translate }}
            <div class="tooltip-container">
              <libero-tooltip-button>
                {{ 'howWeInvest.bulletList2.item2Tooltip' | translate }}
              </libero-tooltip-button>
            </div>
            {{ 'howWeInvest.bulletList2.item2Part2' | translate }}
          </li>
          <li>
            {{ 'howWeInvest.bulletList2.item3' | translate }}
            <div class="tooltip-container">
              <libero-tooltip-button>
                {{ 'howWeInvest.bulletList2.item3Tooltip' | translate }}
              </libero-tooltip-button>
            </div>
          </li>
          <li>
            {{ 'howWeInvest.bulletList2.item4' | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>

</div>

<libero-static-page-footer></libero-static-page-footer>
